import type { CopyShape } from "@tami/core/intl";

import type { HEADER_PUBLIC_COPY_PT_BR } from "../header.copy";

export const HEADER_PUBLIC_COPY_EN_US: CopyShape<
  typeof HEADER_PUBLIC_COPY_PT_BR
> = {
  homeAria: "Tãmi — go to home",
  nav: {
    offer: "What Tãmi offers",
    testimonials: "Testimonials",
    pricing: "Pricing",
  },
  signInDesktop: "sign in",
  signInMobile: "Sign in",
  createAccount: "Create your account",
  menuClose: "Close menu",
  menuOpen: "Open navigation menu",
  mobileNavAria: "Navigation menu",
};
